/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

import { theme } from '@chakra-ui/react';

export const colorsV1 = {
  white: '#FFFFFF',
  black: '#000000',
  stockGray: '#808080',
  lightGray: '#E0E0E0',
  almostWhite: '#F0F0F0',
  dirtyWhite: '#F8F8F8',
  deepSea: '#0A1E32',
  techBlue: '#0082D7',
  skyBlue: '#B3E0F2',
  impactGreen: '#41B47D',
  lightGreen: '#88F8BC',
  darkCrimson: '#B21031',
};
export const colorsV2 = {
  'Text/50': '#FFFFFF',
  'Text/100': '#B9B9B9',
  'Text/200': '#747474',
  'Text/300': '#171717',
  'Text/400': 'linear-gradient(90deg, #001D36 0%, #293500 25%, #293500 75%, #001D36 100%)',
  'Background/50': '#FFFFFF',
  'Background/100': '#FBFBFB',
  'Background/200': 'linear-gradient(180deg, #FDFAF3 0%, #FFF8E8 100%)',
  'Background/300':
    'linear-gradient(90deg, rgba(24, 28, 20, 0.50) 0%, rgba(41, 53, 0, 0.50) 50%, rgba(24, 28, 20, 0.50) 100%), rgba(251, 251, 251, 0.50)',
  'Background/400': 'linear-gradient(90deg, #001D36 0%, #293500 25%, #293500 75%, #001D36 100%)',
  'Background/500': '#181C14',
  'Background/600': '#182F01',
  'Dividers/50': 'rgba(0, 0, 0, 0.10)',
  'Dividers/100': 'rgba(0, 0, 0, 0.30)',
  'Dividers/200': 'rgba(0, 0, 0, 0.60)',
  'Dividers/300': 'linear-gradient(90deg, #001D36 0%, #293500 25%, #293500 75%, #001D36 100%)',
  'Dividers/400': '#181C14',
  'Dividers/500': '#FFFFFF',
  'Dividers/600': 'rgba(24, 47, 1, 0.20)',
  'Primary/50': '#F5FFF5',
  'Primary/100': '#6CDCA1',
  'Primary/200': '#4EBF87',
  'Primary/300': '#005232',
  'Primary/400': '#003921',
  ImpactGreen: '#4EBF87',
  FreshLime: '#C8E56E',
  TechBlue: '#0082D7',
  'TechBlue/50': '#E8F6FF',
  'TechBlue/200': '#0066A9',
  'Success/50': '#F1FFF4',
  'Success/100': '#00C928',
  'Success/200': '#00801A',
  'Success/300': '#006615',
  'Warning/50': '#FFEEDB',
  'Warning/100': '#FFDDAF',
  'Warning/200': '#D8A247',
  'Warning/300': '#805600',
  'Warning/400': '#614000',
  'Danger/50': '#FFEDEA',
  'Danger/100': '#DE3730',
  'Danger/200': '#BA1A1A',
  'Danger/300': '#93000A',
  'Gradients/50': '#FDFAF3',
  'Gradients/100': '#FFF8E8',
  'Gradients/200': '#001D36',
  'Gradients/300': '#293500',
  'Sidebar/Primary/Background': '#182F01',
  'Sidebar/Primary/Selected': '#F0F3ED',
  'Sidebar/Primary/Hovered': '#264606',
  'Sidebar/Secondary/Background': '#EAEEEA',
  'Sidebar/Secondary/Selected': '#BCD89F',
};
export const customColors = {
  ...colorsV1,
  ...colorsV2,
} as const;
export const KaryaColor = {
  ...theme.colors,
  ...customColors,
} as const;

export type KaryaColorType = typeof KaryaColor;
